import React from 'react';
import { HomefieldIconListMenu, HomefieldIconSignCancel } from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from 'utility/constants';

type Props = {
  showMobileMenu: boolean;
  setShowMobileMenu: (value: boolean) => void;
  viewTopNavAnalyticsEventHandler: () => void;
  setShowProgressiveTaxo: () => void;
  showProgressiveTaxo: boolean;
};

const MobileMenuToggleButton = ({
  showMobileMenu,
  setShowMobileMenu,
  viewTopNavAnalyticsEventHandler,
  setShowProgressiveTaxo,
  showProgressiveTaxo,
}: Props) => {
  const mobileMenuToggleButtonEventHandler = () => {
    viewTopNavAnalyticsEventHandler();
    if (showProgressiveTaxo) {
      setShowProgressiveTaxo();
    } else setShowMobileMenu(!showMobileMenu);
  };

  const showMobileMenuEventHandler = (event: React.KeyboardEvent) => {
    if (event.keyCode === KEY_CODES.ENTER || event.keyCode === KEY_CODES.SPACE) {
      return mobileMenuToggleButtonEventHandler();
    }
    if (event.keyCode === KEY_CODES.TAB && showMobileMenu) {
      return null;
    }
    return setShowMobileMenu(false);
  };

  return (
    <button
      className="header__menu-container hmf-display-flex hmf-flex-column hmf-align-self-center hmf-p-0 hmf-justify-content-center hmf-align-items-center"
      onClick={() => {
        mobileMenuToggleButtonEventHandler();
      }}
      onKeyDown={(event) => showMobileMenuEventHandler(event)}
      aria-label={showMobileMenu ? 'Close Navigation Menu' : 'Open Navigation Menu'}
      type="button"
      tabIndex={0}>
      <div className="header__menu-container--menu-sub-container hmf-p-md-xxs" tabIndex={-1}>
        {showMobileMenu ? (
          <HomefieldIconSignCancel
            width="24px"
            height="24px"
            className="header__menu-container--icon"
          />
        ) : (
          <HomefieldIconListMenu
            width="24px"
            height="24px"
            className="header__menu-container--icon"
          />
        )}
      </div>
    </button>
  );
};

export default MobileMenuToggleButton;
